import React, { lazy, Suspense } from 'react'

import { Logger } from 'logging'
import PropTypes from 'prop-types'
import { TranscriptComponent, VideoV2 } from 'secondstepVideo'

import { DATA_TEST_ID_VIDEO_WRAPPER, WRAPPER_CLASSES } from './constants'
import MenuComponent from './menuComponent'
import { OuterWrapper, TranscriptOuterWrapper, Wrapper } from './style'

const ErrorBoundary = lazy(() => import('utils/importSwap/errorBoundary'))

const VideoComponent = ({
  audioDescriptionTranscript,
  backgroundColor,
  canShowAccessibilityMenu,
  canShowAudioDescriptionButton,
  canShowTranscriptButton,
  dimensionsOffset,
  hasVideoSource,
  onEnded,
  onPlay,
  onStopped,
  scale,
  scaleOffset,
  videoUrl,
  tracks,
  settings,
  poster,
  showTranscript,
  transcript,
  transcriptRendered,
  handleAudioMouseOver,
  handleAudioMouseOut,
  isHovering,
  isAudioHovering,
  handleTranscriptClick,
  isTranscriptActive,
  isAudioDescActive,
  menuBarRenderedForEnglish,
  vtts,
  canShowAudioDesc,
  handleClickAudioDesc,
}) => {
  const appInsightInstance = window.appInsight

  return (
    <OuterWrapper>
      {canShowAccessibilityMenu && menuBarRenderedForEnglish && (
        <MenuComponent
          canShowAudioDescriptionButton={canShowAudioDescriptionButton}
          canShowTranscriptButton={canShowTranscriptButton}
          showTranscript={showTranscript}
          isHovering={isHovering}
          isAudioHovering={isAudioHovering}
          handleTranscriptClick={handleTranscriptClick}
          isTranscriptActive={isTranscriptActive}
          isAudioDescActive={isAudioDescActive}
          transcriptRendered={transcriptRendered}
          canShowAudioDesc={canShowAudioDesc}
          handleClickAudioDesc={handleClickAudioDesc}
          handleAudioMouseOver={handleAudioMouseOver}
          handleAudioMouseOut={handleAudioMouseOut}
        />
      )}
      <Wrapper
        canShowAccessibilityMenu={canShowAccessibilityMenu}
        backgroundColor={backgroundColor}
        className={WRAPPER_CLASSES}
        data-testid={DATA_TEST_ID_VIDEO_WRAPPER}
        dimensionsOffset={dimensionsOffset}
        isTranscriptActive={isTranscriptActive}
        menuBarRenderedForEnglish={menuBarRenderedForEnglish}
        scale={scale}
        scaleOffset={scaleOffset}
      >
        {hasVideoSource && (
          <VideoV2
            appInsightInstance={appInsightInstance}
            isAudioDescActive={isAudioDescActive}
            logger={Logger}
            onEnded={onEnded}
            onPlay={onPlay}
            onStopped={onStopped}
            poster={poster}
            settings={settings}
            tracks={tracks}
            videoUrl={videoUrl}
            transcript={transcript}
            vtts={vtts}
          />
        )}
        {transcriptRendered && (
          <TranscriptOuterWrapper data-testid={'transcript-outer-wrapper'}>
            <Suspense fallback={<p>Please wait&hellip;</p>}>
              <ErrorBoundary message="Problem loading video transcript">
                <TranscriptComponent
                  transcript={transcript}
                  isAudioDescActive={isAudioDescActive}
                  audioDescriptionTranscript={audioDescriptionTranscript}
                ></TranscriptComponent>
              </ErrorBoundary>
            </Suspense>
          </TranscriptOuterWrapper>
        )}
      </Wrapper>
    </OuterWrapper>
  )
}

VideoComponent.propTypes = {
  appInsightInstance: PropTypes.object,
  audioDescriptionTranscript: PropTypes.string,
  backgroundColor: PropTypes.string,
  canShowAccessibilityMenu: PropTypes.bool,
  canShowAudioDescriptionButton: PropTypes.bool,
  canShowTranscriptButton: PropTypes.bool,
  dimensionsOffset: PropTypes.number,
  handleAudioMouseOut: PropTypes.func,
  handleAudioMouseOver: PropTypes.func,
  handleMouseOut: PropTypes.func,
  handleMouseOver: PropTypes.func,
  hasVideoSource: PropTypes.bool,
  isAudioHovering: PropTypes.bool,
  isHovering: PropTypes.bool,
  menuBarRenderedForEnglish: PropTypes.bool,
  onEnded: PropTypes.func,
  onPlay: PropTypes.func,
  onStopped: PropTypes.func,
  scale: PropTypes.number,
  scaleOffset: PropTypes.number,
  videoComponentRef: PropTypes.object,
  videoUrl: PropTypes.string,
  tracks: PropTypes.array,
  settings: PropTypes.object,
  transcript: PropTypes.string,
  transcriptRendered: PropTypes.bool,
  poster: PropTypes.string,
  showTranscript: PropTypes.func,
  handleTranscriptClick: PropTypes.func,
  isTranscriptActive: PropTypes.bool,
  isAudioDescActive: PropTypes.bool,
  vtts: PropTypes.object,
  canShowAudioDesc: PropTypes.bool,
  handleClickAudioDesc: PropTypes.func,
}

VideoComponent.defaultProps = {
  scale: 1,
  vtts: {},
  canShowAudioDesc: false,
}

export default VideoComponent
